import { useQuery } from '@tanstack/react-query'

import { useAuthenticatedUser } from '../../auth/hooks/useAuthenticatedUser'
import {
  fetchProjectmeldingValuelists,
  initialState,
} from '../services/fetchProjectmeldingValuelists'

export { useProjectmeldingValuelists }

const queryKey = 'valuelists-projectmelding'

const useProjectmeldingValuelists = () => {
  const { hasPermissions } = useAuthenticatedUser()

  const { data } = useQuery({
    queryFn: fetchProjectmeldingValuelists,
    queryKey: [queryKey],
    enabled: hasPermissions,
  })

  return {
    data: data || initialState.data,
  }
}
